
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.055 11.783a.22.22 0 01.065.156v1.905a.88.88 0 01-.255.62l-6.19 6.246a.977.977 0 01-1.388 0 .995.995 0 010-1.401l7.457-7.525a.22.22 0 01.31-.001zm6.1-6.456L18 7.675c.404.334.639.832.639 1.357v2.333c0 .243.197.44.44.44h2.921a1 1 0 010 2.001h-4.021a1.32 1.32 0 01-1.32-1.32v-.003l.004-1.884a.22.22 0 00-.37-.161l-3.028 2.802a.22.22 0 00.004.327l2.467 2.178a.66.66 0 01.032.959l-3.515 3.554a1.017 1.017 0 01-1.418.028.962.962 0 01-.045-1.36l.019-.02 2.313-2.334a.22.22 0 00-.01-.319l-3.124-2.782a.22.22 0 01-.074-.164v-2.342a.88.88 0 01.255-.62l2.52-2.542a.568.568 0 00.001-.8.558.558 0 00-.79-.004l-.003.003-3.272 3.302a.977.977 0 01-1.388 0 .995.995 0 010-1.4l3.44-3.472a1.76 1.76 0 011.029-.507l1.438-.182a2.64 2.64 0 012.013.584zM18.639 3c1.095 0 1.983.896 1.983 2.001a1.992 1.992 0 01-1.983 2.001 1.992 1.992 0 01-1.983-2c0-1.106.888-2.002 1.983-2.002z","id":"🎨-Color","fill":"currentColor","stroke":"none","stroke-width":"1","fill-rule":"evenodd"}})])
          )
        }
      }
    